import { render } from "./BaseNav.vue?vue&type=template&id=5b5c47c2&scoped=true"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"

import "./BaseNav.vue?vue&type=style&index=0&id=5b5c47c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b5c47c2"

export default script